// extracted by mini-css-extract-plugin
export default {"body":"WebsiteInfoModal_body__JoC6G"};